<template>

  <div class="mycontainer">
    <div class="headerclass">{{titleDic[typeindex]}}详情</div>
    <button class="submitclass" @click="$router.go(-1)">返回</button>

    <div class="bottom" v-if="typeindex!=5&&typeindex!=6">
      <div class="titlename textline1">{{dataDic.title}}</div>
      <div class="depart">{{dataDic.pubdate}}&nbsp&nbsp&nbsp信息来源：{{dataDic.urlName}}</div>
      <div style="width: 80%;margin: 0 auto;" v-html="dataDic.detailhtml"></div>
    </div>
    <div class="bottom" v-if="typeindex==5||typeindex==6">
      <div class="titlename textline1">{{dataDic.enterName}}</div>
      <div class="depart">{{dataDic.pubdate?dataDic.pubdate:dataDic.pubDate}}&nbsp&nbsp&nbsp信息来源：{{dataDic.depart}}</div>
      <div style="width: 80%;margin: 0 auto;">{{dataDic.content}}</div>
    </div>


  </div>

</template>

<script>
  import * as api from "../../utils/api"
  import axios from "axios";

  export default {
    components: {

    },
    name: "information-detail",
    data(){
      return{
        keyword:'',
        userName:'',
        loading:false,
        id:this.$route.query.id,
        type:{0:'国内科创动态,国外科创动态',1:'推荐项目',2:'通知公告',3:'国内科创动态',4:'国外科创动态'},
        typeindex:Number(this.$route.query.typeindex),
        dataDic:{},
        titleDic:{
          0:'科创（国合）头条',
          1:'驻外科技机构推荐项目',
          2:'通知公告',
          3:'国内科技动态',
          4:'海外科技动态',
          5:'今日提醒',
          6:'今日预警'
        }
      }
    },
    watch:{
    },
    mounted(){


      if(this.typeindex==6){
        this.getWarningDetail();
      }else if(this.typeindex==5){

        this.getRemindDetail();
      }else{
        this.getInformationById();

      }
    },
    methods:{
      getInformationById() {
        this.loading=true;
        var self = this;
        api.getInformationById({
          id: this.id,
        })
          .then(rs => {
            self.loading=false;

            if (rs.status == 200) {
              self.dataDic=rs.data;

            } else {
              self.$message.error(rs.message)

            }

          })
          .catch(err => {
            self.$message.error(err)
            self.loading=false;

          })
      },
      //预警
      getWarningDetail() {

        this.loading=true;
        var self = this;
        api.getWarningDetail({
          id: this.id,
        })
          .then(rs => {
            self.loading=false;

            if (rs.status == 200) {
              self.dataDic=rs.data;

            } else {
              self.$message.error(rs.message)

            }

          })
          .catch(err => {
            self.$message.error(err)
            self.loading=false;

          })
      },
      //今日提醒
      getRemindDetail() {

        this.loading=true;
        var self = this;
        api.getRemindDetail({
          id: this.id,
        })
          .then(rs => {
            self.loading=false;

            if (rs.status == 200) {

              self.dataDic=rs.data;

            } else {
              self.$message.error(rs.message)

            }

          })
          .catch(err => {
            self.$message.error(err)
            self.loading=false;

          })
      },

      handleCurrentChange: function (val) {
        this.startPage = Number(`${val}`);
        this.getInformationDetail();
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.endPage = Number(`${val}`);
        this.getInformationDetail();
      },
      //获取详情信息
      getDetailInfor(roleId){

        this.$router.push({
          name: 'informationdetail',

        })
      },

      handleSelect(item) {
        // console.log(item);
        this.getInformationDetail();
      },

    }
  }
</script>

<style lang="less" type="text/less" rel="stylesheet/less" scoped>
  .mycontainer{
    .detailinfor{
      cursor: pointer;
    }
    .detailinfor:hover{
      color: #0a7afc;
    }
    background: #fff;
    width: 100%;
    min-height: calc(100vh - 70px);
    position: relative;
    .headerclass{
      padding: 20px 0;
      margin: 0 20px;
      height: 15px;
      font-size: 16px;
      color: #2a3138;
      border-bottom: 1px solid #e6eaf0;
    }
    .submitclass{
      position: absolute;
      right: 0px;
      top: 10px;
    }
    .bottom{
      .titlename{
        font-size: 24px;
        color: #0a7afc;
        margin: 0 auto;
        width: 80%;
        text-align: center;
        line-height: 100px;

      }
      .depart{
        color: #808b9e;
        font-size: 14px;
        margin: 0 auto;
        text-align: center;
        margin-bottom: 30px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/home/informationDetail.vue